import NProgress from 'nprogress';

// checks if entity has children or not
export const checkDeleteValidity = (entity) => {
    if (entity?.children?.length > 0) {
        return true;
    }
    return false;
};

export const executeLoader = (flag) => {
    if (flag) {
        NProgress.start();
    } else {
        NProgress.done();
    }
};



const companyFeatures = {
    2: ['assurance-level', 'feature-x'],
};

export function hasCompanyFeatures(companyId, featureKeys = []) {
    const enabledFeatures = companyFeatures[companyId] || [];
    return featureKeys.every((key) => enabledFeatures.includes(key));
}